export const CUSTOMERAUTH_DETAIL_REQUEST=`CUSTOMERAUTH_DETAIL_REQUEST`;
export const CUSTOMERAUTH_DETAIL_REQUEST_ERROR=`CUSTOMERAUTH_DETAIL_REQUEST_ERROR`;
